import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/industries.css';
import bankingImg from '../../assets/banking.jpg';

const Banking = () => (
  <div
    className="industry-page"
    style={{ backgroundImage: `url(${bankingImg})` }}
  >
    <motion.div
      className="industry-content"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1>Banking</h1>
      <p>
        Creating secure, scalable digital banking platforms to streamline customer experience and ensure regulatory compliance.
      </p>
      <ul className="bullet-points">
        <li>🏦 Digital banking & core systems.</li>
        <li>📲 Wallets & secure payment gateways.</li>
        <li>🛡️ KYC/AML integrations.</li>
        <li>📉 Credit scoring & loan automation.</li>
      </ul>
    </motion.div>
  </div>
);

export default Banking;
